import {useBroadcast} from '@/composables'
import {screensharing} from '@/messages'
import {mediator} from '@communication'
import {useDisplayMedia, useEventBus} from '@vueuse/core'
import {defineStore} from 'pinia'
import {computed} from 'vue'
import {ref, watchEffect} from 'vue'

export const useScreenShareStore = defineStore('screenShare', () => {
  const broadcast = useBroadcast()
  const {stream, start, stop} = useDisplayMedia({
    enabled: false,
    video: {
      width: {
        ideal: 1280,
      },
      height: {
        ideal: 720,
      },
    },
    audio: false,
  })
  const isScreenSharing = computed(() => !!stream.value)
  watchEffect(async () => {
    if (isScreenSharing.value) {
      await mediator.connection?.startScreensharing(stream.value)
      broadcast(screensharing.startMessage(stream.value!.id))
    } else {
      broadcast(screensharing.stopMessage())
    }
  })
  const remoteScreenShare = ref<MediaStream | null>(null)
  useEventBus<{stream: MediaStream}>('strategy:screensharingStarted:viewer').on(data => {
    const {stream} = data
    remoteScreenShare.value = stream
  })
  useEventBus('screensharing:stop').on(() => {
    remoteScreenShare.value = null
  })
  return {stream, start, stop, isScreenSharing, remoteScreenShare}
})
